import { VacationPeriod } from '@/features/Collaborators/Edit/Types';
import { LEGACY_PERIODS_CUTOFF_DATE } from '@/features/Vacations/vacations.definitions';

type PeriodLike = Pick<VacationPeriod, 'startDate' | 'endDate'>;

export function isLegacyPeriod(
    period: PeriodLike,
    cutoffIso: string = LEGACY_PERIODS_CUTOFF_DATE
): boolean {
    return Boolean(period.startDate) && period.startDate < cutoffIso;
}

export function countVacationDays(start?: string, end?: string): number {
    if (!start || !end) return 0;

    const startDate = new Date(`${start}T00:00:00Z`);
    const endDate = new Date(`${end}T00:00:00Z`);
    const days = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24) + 1;

    return Number.isFinite(days) && days > 0 ? days : 0;
}

export function hasStarted(period: PeriodLike, todayIso: string): boolean {
    return Boolean(period.startDate) && period.startDate <= todayIso;
}

export function sumStartedDays(periods: PeriodLike[], todayIso: string): number {
    return periods
        .filter((period) => hasStarted(period, todayIso))
        .reduce((total, period) => total + countVacationDays(period.startDate, period.endDate), 0);
}

export function sumScheduledDays(periods: PeriodLike[], todayIso: string): number {
    return periods
        .filter((period) => !hasStarted(period, todayIso))
        .reduce((total, period) => total + countVacationDays(period.startDate, period.endDate), 0);
}
